/**
 * Owner: Masa Bayu
 * File: script-identity.ts
 * Date:Time: 2026-09-19 15:55
 * Description: Canonical script identity create/normalize (GL-02).
 */
import { QxLanguageError } from './errors';
import { QX_SCRIPT_MODEL_VERSION, isQxScriptDirection, } from './script-codes';
import { getRegisteredScript, isRegisteredScriptId } from './script-registry';
import { assertScriptId } from './script-hints';
export function createQxScriptIdentity(input) {
    const scriptId = assertScriptId(input.scriptId);
    const registered = getRegisteredScript(scriptId);
    if (input.defaultDirection !== undefined && !isQxScriptDirection(input.defaultDirection)) {
        throw new QxLanguageError('INVALID_INPUT', `invalid script defaultDirection: ${String(input.defaultDirection)}`);
    }
    if (registered) {
        return Object.freeze({
            modelVersion: QX_SCRIPT_MODEL_VERSION,
            scriptId: registered.scriptId,
            familyId: registered.familyId,
            defaultDirection: input.defaultDirection ?? registered.defaultDirection,
            label: registered.label,
            variants: registered.variants,
            registered: true,
        });
    }
    // Unknown but shape-valid ISO 15924–like code — allowed as unregistered identity
    return Object.freeze({
        modelVersion: QX_SCRIPT_MODEL_VERSION,
        scriptId,
        familyId: 'other',
        defaultDirection: input.defaultDirection ?? 'auto',
        label: scriptId,
        variants: Object.freeze([]),
        registered: false,
    });
}
export function listScriptVariants(scriptId) {
    const id = assertScriptId(scriptId);
    const entry = getRegisteredScript(id);
    if (!entry) {
        return Object.freeze([]);
    }
    return entry.variants;
}
export function assertRegisteredScriptId(scriptId) {
    const id = assertScriptId(scriptId);
    if (!isRegisteredScriptId(id)) {
        throw new QxLanguageError('NOT_FOUND', `scriptId not in QX registry: ${id}`);
    }
    return id;
}
//# sourceMappingURL=script-identity.js.map